import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player/lazy';

import { ReactComponent as Close } from '../../images/icons/close.svg';
import BallPit from '../Common/BallPit';
import { PrimaryLink } from '../Common/Links';
import PageSection from '../PageSections/PageSection';
import * as styles from './BrandCampaignHero.module.scss';

export const CustomModal = ({ open, onClose, className, children }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (open) {
      document.addEventListener('keydown', handleKeyDown);
    } else {
      document.removeEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div data-analytics-component={'modal'} className={[styles.modalOverlay, className].join(' ')} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.modalClose} onClick={onClose} aria-label="Close modal">
          <Close />
        </button>
        {children}
      </div>
    </div>
  );
};

export default function BrandCampaignHero({ page }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div
      data-analytics-section="brand-campaign-hero"
      className={styles.heading}
      style={{ backgroundImage: `url('${page.headingBackgroundImage?.file?.url}')` }}
    >
      <BallPit className={styles.canvas} />
      <PageSection isTopSection={true} wide className={styles.heroWrapper} innerClassName={styles.hero}>
        <div className={styles.copy}>
          <h1>{page.heading}</h1>
          {page.headingCtAs && (
            <>
              <PrimaryLink
                tabIndex="0"
                isButton={true}
                label={page.headingCtAs[0].linkText}
                onClick={handleOpen}
                onKeyDown={(e) => e.key === 'Enter' && handleOpen()}
              />
              <CustomModal open={open} onClose={handleClose}>
                <div className={styles.video}>
                  <ReactPlayer url={page.headingCtAs[0].url} playing={open} controls={false} width="100%" />
                </div>
              </CustomModal>
            </>
          )}
        </div>
      </PageSection>
    </div>
  );
}
